export default ({ draftState = 'editing', isCourseDraft = true }) => {
  const isCourseInReviewOrApproved =
    isCourseDraft && ['in_review', 'approved'].includes(draftState);

  const isNonCourseDraftWithoutState = !isCourseDraft && draftState === null;

  return isCourseInReviewOrApproved || isNonCourseDraftWithoutState;
};
